module.exports = __webpack_public_path__ + "img/jj_logo_2020.8f7ca38f.png";